import { type ComponentProps, memo } from 'react';

import { cn } from '@air/utils-tailwind';

type InfoPanelDetailHeaderProps = ComponentProps<'h3'>;

export const InfoPanelDetailTitle = memo(({ className, ...props }: InfoPanelDetailHeaderProps) => (
  <h3 className={cn('line-clamp-2 ads:text-primary text-14 text-gray-12', className)} {...props} />
));

InfoPanelDetailTitle.displayName = 'InfoPanelDetailTitle';
